import { useState, useEffect } from "react";

const BREAKPOINT = 768;

export function useMobile() {
  const [mobile, setMobile] = useState(
    () => window.innerWidth < BREAKPOINT || process.env.REACT_APP_MOBILE === "true"
  );
  useEffect(() => {
    if (process.env.REACT_APP_MOBILE === "true") return;
    const mq = window.matchMedia(`(max-width: ${BREAKPOINT - 1}px)`);
    const handler = (e) => setMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);
  return mobile;
}
